import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../../store/rootReducer";
import { SortingType } from "pages/category/types";
import { Product } from "features/ProductReel/types";
import Axios from "axios";
import { ActiveFilter } from "features/Filters/types";
import { API_URL } from "config";
import { activeFiltersToURLParams } from "features/utils";
import {
  setFilters,
  setInitialLoad,
  setMaxPrice,
} from "features/Filters/filtersSlice";
import {
  setTotalItems,
  setTotalPages,
} from "features/pagination/paginationSlice";
import { batch } from "react-redux";
import { RequestStatus } from "features/types";
interface CategoryInitialState {
  activeSortingType: SortingType;
  filteredProducts: Product[];
  productsStatus: RequestStatus | null;
}

const initialState: CategoryInitialState = {
  activeSortingType: SortingType.priceasc,
  filteredProducts: [],
  productsStatus: null,
};

const category = createSlice({
  name: "productsSlice",
  initialState,
  reducers: {
    setActiveSortingType(state, action) {
      state.activeSortingType = action.payload;
    },
    setFilteredProducts(state, action) {
      state.filteredProducts = action.payload;
      state.productsStatus = RequestStatus.SUCCESS;
    },
    setProductsStatus(state, action) {
      state.productsStatus = action.payload;
    },
  },
});
export const { setActiveSortingType, setFilteredProducts, setProductsStatus } =
  category.actions;

export const selectActiveSortingType = (state: RootState) =>
  state.category.activeSortingType;
export const selectProductsStatus = (state: RootState) =>
  state.category.productsStatus;
export const selectFilteredProducts = (state: RootState) =>
  state.category.filteredProducts;

export const fetchFilteredProducts =
  (
    filters: ActiveFilter[],
    page: number = 1,
    activeCategorySortingType: string = SortingType.priceasc
  ) =>
  async (dispatch: any, getState: () => RootState) => {
    dispatch(setProductsStatus(RequestStatus.LOADING));
    try {
      const filtersAsParams = activeFiltersToURLParams(filters);
      const route =
        window.location.pathname === "/promotions" ? "promotions" : "products";
      const sort =
        activeCategorySortingType &&
        `${activeCategorySortingType
          .split(",")
          .map((item) => `&sort=${item}`)
          .join("")}`;
      const result = await Axios.get(
        `${API_URL}/${route}?size=12&page=${page}${filtersAsParams}${sort}`
      );

      if (!getState().filters.initialLoad) {
        dispatch(setInitialLoad(true));
      }

      batch(() => {
        dispatch(setFilteredProducts([...result.data.data]));
        dispatch(setFilters(result.data.filters));
        dispatch(setMaxPrice(result.data.maxPrice));
        dispatch(setTotalPages(result.data.pages));
        dispatch(setTotalItems(result.data.filteredCout));
      });
    } catch (error: any) {
      console.log(
        `Error in categorySlice fetchFilteredProducts: ${error.message}`
      );
    }
  };

export default category.reducer;
